<svelte:options customElement={{
  tag: 'box-block',
  shadow: 'none',
  props: {
    variant: { reflect: true, type: 'String' },
    size: { reflect: true, type: 'String' },
    title: { reflect: true, type: 'String' },
    text: { reflect: true, type: 'String' }
  }
}} />

<script>
  import { onMount } from 'svelte';
  /**
   * Box：ボックスコンテナ
   * パーツライブラリ準拠の mod-box 構造
   * @prop {string} variant - 'color' | 'border' | 'label'
   * @prop {string} size - 'md' | 'sm'
   * @prop {string} title - ボックスタイトル（label バリアントのみ）
   * @prop {string} text - ボックス内テキスト
   */
  export let variant = 'color';
  export let size = 'md';
  export let title = '';
  export let text = '';

  $: className = (() => {
    switch (variant) {
      case 'color':
        return `mod-box _color _${size}`;
      case 'border':
        return `mod-box _border _${size}`;
      case 'label':
        return `mod-box-label _${size}`;
      default:
        return `mod-box _color _${size}`;
    }
  })();

  let wrapperEl;
  let bodyEl;

  onMount(() => {
    if (!text) {
      const host = wrapperEl.parentElement;
      const target = bodyEl || wrapperEl;
      const nodesToMove = [];
      host.childNodes.forEach(node => {
        if (node !== wrapperEl) nodesToMove.push(node);
      });
      nodesToMove.forEach(node => target.appendChild(node));
    }
  });
</script>

{#if variant === 'label'}
  <div class={className} bind:this={wrapperEl}>
    {#if title}
      <div class="mod-box-label-title">
        {@html title}
      </div>
    {/if}
    <div class="mod-box-label-body" bind:this={bodyEl}>
      {#if text}
        {@html text}
      {/if}
    </div>
  </div>
{:else}
  <div class={className} bind:this={wrapperEl}>
    {#if text}
      {@html text}
    {/if}
  </div>
{/if}
